"use strict";
/* Postcode lookup (WFFM forms) */
// There are two different submit methods: for Sitecore forms and all other forms
export default class PostcodeLookup {
  constructor(element) {
    this.root = element;
    this.sitecoreForm = document.querySelector(".js-sitecore-form form");
    this.customForm = document.querySelector(".wffm-form:not(.js-sitecore-form) form");
    this.searchButton = this.root.querySelector(".address-search-button");
    this.searchInputRow = this.root.querySelector(".address-input-row");
    this.searchInput = this.root.querySelector(".address-search-input");
    this.addressResultsDiv = this.root.querySelector(".address-results");
    this.addressErrorsRow = this.root.querySelector(".address-errors-row");
    this.addressErrors = this.addressErrorsRow.querySelector(".address-errors");
    this.addressSelectionErrorsRow = this.root.querySelector(".address-selection-errors-row");
    this.addressSelectionErrors = this.addressSelectionErrorsRow.querySelector(".address-errors");
    this.addressResults = this.root.querySelector(".address-results-options");
    this.addressOutput = this.root.querySelector(".address-output");
    this.addressFields = this.addressOutput.querySelectorAll(".js-address-field");
    this.addressResultsSelect = this.addressResults.getElementsByTagName("select")[0];
    this.confirmAddress = this.root.querySelector(".js-address-confirm");
    this.addressTextarea = this.root.querySelector(".address-textarea");
    this.manualAddressRow = this.root.querySelector(".manual-address");
    this.manualAddress = this.manualAddressRow.querySelector(".js-manual-address");
    this.requiredFields = this.root.querySelectorAll("[data-required]");
    this.requiredOutputFields = this.addressOutput.querySelectorAll("[data-required]");
    this.errorFocus = null;
    this.bindEvents();
    this.checkManualFields();
    this.apiKey = this.root.dataset.key;
    this.apiEndpoint = this.root.dataset.url;
    this.data = [];
  }

  addressSearch() {
    const BUTTON = this.searchButton,
      POSTCODE = this.searchInput.value;
    if (POSTCODE.length <= 0) {
      this.addressErrors.innerHTML = 'Please enter a valid postcode';
      this.addressErrors.classList.add("field-validation-error");
    } else {
      BUTTON.getElementsByTagName("span")[1].innerHTML = "Searching...";
      this.getAddressesAjax(POSTCODE);
    }
  }

  getAddressesAjax(POSTCODE) {
    this.data = [];
    fetch(`/api/findaddress?postcode=${POSTCODE}`)
      .then((response) => response.json())
      .then((response) => {
        if (response.data.addresses.length > 0) {
          this.data = response.data.addresses;
          this.checkData(this.data);
        } else {
          this.addressErrors.innerHTML = 'Please enter a valid postcode';
          this.addressErrors.classList.add("field-validation-error");
        }
      })
      .catch(() => {
        this.addressErrors.innerHTML = 'Please enter a valid postcode';
        this.addressErrors.classList.add("field-validation-error");
      })
      .finally(() => (this.searchButton.getElementsByTagName("span")[1].innerHTML = "Find address"));
  }

  checkData(data) {
    let noError = false;
    if (data.length <= 0) {
      // If no addresses returned and it isn't a single result
      // Show the error message
      this.addressErrors.innerHTML = 'Please enter a valid postcode';
      this.addressErrors.classList.add("field-validation-error");
    } else {
      noError = true;
      this.addressOutput.querySelector(".js-address-postcode").classList.remove("parsley-error");
    }

    if (noError) {
      this.addressErrors.innerHTML = "";
      this.addressErrors.classList.remove("field-validation-error");

      if (data.length === 1) {
        // Single result
        this.fillFields(data[0]);
      } else {
        // Multiple reults, show dropdown
        let addressOutput;

        for (let i = 0; i < data.length; i++) {
          const ADDRESSLINE1 = data[i].addressLine1,
            ADDRESSLINE2 = data[i].addressLine2,
            CITY = data[i].postTown,
            COUNTY = data[i].county,
            POSTCODE = data[i].postcode;

          let addressLine = ADDRESSLINE1 ? ADDRESSLINE1 + ", " : "";
          addressLine += ADDRESSLINE2 ? ADDRESSLINE2 + ", " : "";
          addressLine += CITY ? CITY + ", " : "";
          addressLine += COUNTY ? COUNTY + ", " : "";
          addressLine += POSTCODE;

          addressOutput += '<option value="' + i + '">' + addressLine;
          ("</option>");
        }

        this.manualAddressRow.classList.add("address-search--hide");
        this.searchInputRow.classList.add("address-search--hide");
        this.addressResultsDiv.classList.add("address-search--show");
        this.addressResults.classList.add("address-search--show");

        const selectField = this.addressResults.getElementsByTagName("select")[0];
        selectField.innerHTML = addressOutput;
        selectField.focus();

      }
    }
  }

  addressFilter() {
    const OPTION = this.addressResultsSelect;
    this.checkData([this.data[OPTION.selectedIndex]]);
    this.searchButton.getElementsByTagName("span")[1].innerHTML = "Find address";
  }

  fillFields(data) {
    this.addressOutput.querySelector(".js-address-1").value = data.addressLine1;
    this.addressOutput.querySelector(".js-address-2").value = data.addressLine2;
    if (this.addressOutput.querySelector(".js-address-3")) {
        this.addressOutput.querySelector(".js-address-3").value = data.addressLine3;
    }
    if (this.addressOutput.querySelector(".js-address-4")) {
        this.addressOutput.querySelector(".js-address-4").value = data.addressLine4;
    }
    this.addressOutput.querySelector(".js-address-city").value = data.postTown;
    this.addressOutput.querySelector(".js-address-county").value = data.county;
    this.addressOutput.querySelector(".js-address-postcode").value = data.postcode;

    this.populateTextarea();
    this.requiredFields = this.root.querySelectorAll("[data-required]");
    for (let i = 0; i < this.requiredFields.length; i++) {
      this.validateFields(this.requiredFields[i]);
    }
    this.showFields();

    return false;
  }

  populateTextarea() {
    // Only fill textarea if all required fields filled
    this.requiredFields = this.root.querySelectorAll("[data-required]");
    let countInvalidFields = 0;
    for (let i = 0; i < this.requiredFields.length; i++) {
      let isFieldValid = this.validateFields(this.requiredFields[i]);
      if (!isFieldValid) {
        countInvalidFields++;
      }
    }

    if (countInvalidFields === 0) {
      const ADDRESS1 = this.addressOutput.querySelector(".js-address-1").value;
      const ADDRESS2 = this.addressOutput.querySelector(".js-address-2").value;
      let ADDRESS3 = "";
      if (this.addressOutput.querySelector(".js-address-3")) {
        ADDRESS3 = this.addressOutput.querySelector(".js-address-3").value;
      }
      let ADDRESS4 = "";
      if (this.addressOutput.querySelector(".js-address-4")) {
       ADDRESS4 = this.addressOutput.querySelector(".js-address-4").value;
      }
      const CITY = this.addressOutput.querySelector(".js-address-city").value;
      const COUNTY = this.addressOutput.querySelector(".js-address-county").value;
      const POSTCODE = this.addressOutput.querySelector(".js-address-postcode").value;
      const COUNTRY = this.addressOutput.querySelector(".js-address-country").value;

      let textareaOutput = ADDRESS1 ? "Address1|" + ADDRESS1 + "^" : "Address1|^";
      textareaOutput += ADDRESS2 ? "Address2|" + ADDRESS2 + "^" : "Address2|^";
      if (this.addressOutput.querySelector(".js-address-4")) {
        textareaOutput += ADDRESS3 ? "Address3|" + ADDRESS3 + "^" : "Address3|^";
      }
      if (this.addressOutput.querySelector(".js-address-4")) {
        textareaOutput += ADDRESS4 ? "Address4|" + ADDRESS4 + "^" : "Address4|^";
      }
      textareaOutput += CITY ? "TownOrCity|" + CITY + "^" : "TownOrCity|^";
      textareaOutput += COUNTY ? "County|" + COUNTY + "^" : "County|^";
      textareaOutput += POSTCODE ? "Postcode|" + POSTCODE + "^" : "Postcode|^";
      textareaOutput += "Country|" + COUNTRY;

      this.addressTextarea.getElementsByTagName("textarea")[0].value = textareaOutput;
    } else {
      this.addressTextarea.getElementsByTagName("textarea")[0].value = "";
    }
  }

  showManualFieldsHandler(ev) {
    ev.preventDefault();
    this.showManualFields();
  }

  showManualFields() {
    this.searchInput.removeAttribute("data-required");
    this.showFields();
    this.addressErrors.innerHTML = "";
    this.addressOutput.querySelector(".js-address-postcode").classList.remove("parsley-error");
    this.addressErrors.classList.remove("field-validation-error");
  }

  submitHandlerSitecore(form, event) {
    // validate only form that is not hidden (.js-checkbox-toggle displays second postcode lookup that is initially hidden)
    const checkboxToggle = this.root.closest(".js-checkbox-toggle");
    if (!checkboxToggle || checkboxToggle.classList.contains("js-active")) {
      this.requiredFields = this.root.querySelectorAll("[data-required]");
      let countInvalidFields = 0;
      for (let i = 0; i < this.requiredFields.length; i++) {
        let isFieldValid = this.validateFields(this.requiredFields[i]);
        if (!isFieldValid) {
          countInvalidFields++;
        }
      }

      if (countInvalidFields === 0) {
        return true;
      } else {
        event.preventDefault();
        const validForm = $(this.sitecoreForm).valid();
        setTimeout(() => {
          const allVisibleErrors = this.sitecoreForm.querySelectorAll(
            ".input-validation-error, .address-search--show select, .has-error > *[data-required]:not([style*='display:none']"
          );
          if (allVisibleErrors.length) {
            allVisibleErrors[0].focus();
          }
        }, 300);
      }
    }
  }

  submitHandlerCustomForm(form, event) {
    // validate only form that is not hidden (.js-checkbox-toggle displays second postcode lookup that is initially hidden)
    const checkboxToggle = this.root.closest(".js-checkbox-toggle");
    if (!checkboxToggle || checkboxToggle.classList.contains("js-active")) {
      this.requiredFields = this.root.querySelectorAll("[data-required]");

      let countInvalidFields = 0;
      for (let i = 0; i < this.requiredFields.length; i++) {
        let isFieldValid = this.validateFields(this.requiredFields[i]);
        if (!isFieldValid) {
          countInvalidFields++;
        }
      }

      if (countInvalidFields === 0) {
        return true;
      } else {
        event.preventDefault();
        setTimeout(() => {
          const allVisibleErrors = this.customForm.querySelectorAll(
            ".input-validation-error, .parsley-error, .address-search--show > select, .has-error > *[data-required]:not([style*='display:none']"
          );
          if (allVisibleErrors.length) {
            allVisibleErrors[0].focus({
              preventScroll: true,
            });
            allVisibleErrors[0].scrollIntoView();
          }
        }, 150);
      }
    }
  }

  validateFields(field) {
    const wheelchairAddressForm = document.querySelector(".js-address-form");
    let parent = field.parentNode,
      addressLength = this.searchInput.value.length;
    if (field.hasAttribute("data-required")) {
      if (field.value.replace(/^\s+/g, "").length <= 0 && !wheelchairAddressForm.hasAttribute("hidden")) {
        let errorText = field.getAttribute("data-val-required");
        parent.classList.add("has-error");
        parent.querySelector(".help-block").innerHTML = errorText;
        parent.querySelector(".help-block").classList.add("field-validation-error");
        parent.querySelector(".help-block").classList.remove("field-validation-valid");
        this.errorFocus = this.searchInput;

        if (this.addressResults.classList.contains("address-search--show")) {
          this.addressSelectionErrors.innerHTML = 'Please confirm your address';
          this.addressSelectionErrors.classList.add("field-validation-error");
        }

        if (
          addressLength > 0 &&
          !this.addressResults.classList.contains("address-search--show") &&
          !this.addressOutput.classList.contains("address-search--show")
        ) {
          this.addressErrors.innerHTML = "Please search for or manually input your address";
          this.addressErrors.classList.add("field-validation-error");
          this.errorFocus = this.searchButton;
        }

        return false;
      } else {
        parent.classList.remove("has-error");
        parent.querySelector(".help-block").innerHTML = "";
        parent.querySelector(".help-block").classList.add("field-validation-valid");
        parent.querySelector(".help-block").classList.remove("field-validation-error");
        return true;
      }
    }
  }

  showFields() {
    this.manualAddressRow.classList.add("address-search--hide");
    this.searchInputRow.classList.add("address-search--hide");
    this.addressOutput.classList.add("address-search--show");
    this.addressResultsDiv.classList.remove("address-search--show");
    this.addressResults.classList.remove("address-search--show");
    this.addressResultsDiv.classList.add("address-search--hide");
    this.addressResults.classList.add("address-search--hide");

    // having shown the fields, add focus to the address line 1 field for screen reader announcement
    const addressLine1 = document.querySelector('.js-address-1');
    
    // There is no address line 1, Don't continue
    if (!addressLine1) {
      return;
    }

    addressLine1.focus();
  }

  checkManualFields() {
    //If manual fields are pre-filled on page load e.g. form session values, show fields
    let emptyFieldCounter = 0;
    for (let i = 0; i < this.requiredOutputFields.length; i++) {
      if (this.requiredOutputFields[i].value.length <= 0) {
        emptyFieldCounter++;
      }
    }
    if (emptyFieldCounter == 0) {
      this.showManualFields();
    }
  }

  bindEvents() {
    this.searchButton.addEventListener("click", this.addressSearch.bind(this));
    this.manualAddress.addEventListener("click", this.showManualFieldsHandler.bind(this));
    this.confirmAddress.addEventListener("click", this.addressFilter.bind(this));
    for (let i = 0; i < this.addressFields.length; i++) {
      this.changeListener = this.populateTextarea.bind(this);
      this.addressFields[i].addEventListener("change", this.changeListener);
      this.addressFields[i].addEventListener("keyup", this.changeListener);
    }
    if (this.sitecoreForm) {
      const submitButton = this.sitecoreForm.querySelector("input[type=submit]");
      submitButton.addEventListener("click", this.submitHandlerSitecore.bind(this, this.sitecoreForm));
    } else {
      this.customForm.addEventListener("submit", this.submitHandlerCustomForm.bind(this, this.customForm));
    }
  }
}
